import * as Actions from './SessionPollActions';

const initialState = {
  fetching: false,
  polls: [],
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_POLL_REQUEST: {
      return { ...state, fetching: true };
    }
    case Actions.GET_SESSION_POLL_SUCCESS: {
      const { polls } = action.payload;
      return {
        ...state,
        polls: polls,
        fetching: false,
        error: null
      };
    }
    case Actions.GET_SESSION_POLL_FAILURE: {
      return { ...state, error: action.error, fetching: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionPoll/SessionPollReducer.js